import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const navigation = [
    { name: 'HOME', href: '/' },
    { name: 'SERMONS', href: '/sermons' },
    { name: 'BIBLE STUDIES', href: '/bible-studies' },
    { name: 'EVENTS', href: '/events' },
    { name: 'PRAYER', href: '/prayer' },
    { name: 'BLOG', href: '/blog' },
    { name: 'OUTREACH', href: '/outreach' },
    { name: 'SUBSCRIBE', href: '/subscribe' },
    { name: 'ABOUT', href: '/about' },
    { name: 'CONTACT', href: '/contact' }
  ];

  const handleNavigation = (href) => {
    navigate(href);
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md z-50 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <div 
            className="flex items-center space-x-3 cursor-pointer"
            onClick={() => navigate('/')}
          >
            <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_elbethel-worship/artifacts/6rez83rp_El%20bethel%20Transparent%20Logo.png"
                alt="El Bethel Ministries"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="text-xs lg:text-sm font-bold text-gray-800 font-display">
              <div className="leading-tight">EL BETHEL</div>
              <div className="leading-tight">MINISTRIES</div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navigation.map((item) => (
              <button
                key={item.name}
                onClick={() => handleNavigation(item.href)}
                className="text-sm font-medium text-gray-700 hover:text-[#f17b21] transition-colors duration-200 font-sans h-8 flex items-center"
              >
                {item.name}
              </button>
            ))}
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2"
          >
            {isMenuOpen ? (
              <X className="h-6 w-6 text-gray-700" />
            ) : (
              <Menu className="h-6 w-6 text-gray-700" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden pb-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-4 pt-4">
              {navigation.map((item) => (
                <button
                  key={item.name}
                  onClick={() => handleNavigation(item.href)}
                  className="text-left text-sm font-medium text-gray-700 hover:text-[#f17b21] transition-colors duration-200 font-sans"
                >
                  {item.name}
                </button>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;